'use client';

export default function Accordion({ title, text, newlines, titleClass, rank, onMouseEnter, onMouseLeave }) {

    function convertNewlines(string) {
        return string.replace(/\n/g, "<br/>");
    }    
    function stripNewlines(string) {
        return string.replace(/\n/g, "");
    }
    let html;
    switch (newlines) {
        case "convert":
            html = convertNewlines(text);
            break;
        case "strip":
            html = stripNewlines(text);
            break;
        default:
            html = text;
            break;
    } 

    const useRank = rank ? rank : "h3";

    let titleClassName = "font-vg-medium text-black text-2xl shrink";
    if (titleClass) {
        titleClassName = `${titleClassName} ${titleClass}`;
    }

    const onMouseEnterHandler = () => {
        if (onMouseEnter) {
            onMouseEnter();
        }
    }

    const onMouseLeaveHandler = () => {
        if (onMouseLeave) {
            onMouseLeave();
        }
    }

    return (
        <details className="box-border w-full flex flex-col items-stretch p-6 rounded-lg shadow-standard bg-white">
            <summary 
                className="flex items-center justify-between"
                onMouseEnter={onMouseEnterHandler}
                onMouseLeave={onMouseLeaveHandler}
            >
                {useRank === "h2" ? (
                    <h2 className={titleClassName}>{title}</h2>
                ) : (
                    <h3 className={titleClassName}>{title}</h3>
                )}
                <svg className="w-5 h-5 text-blue shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path fillRule="evenodd" d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z" clipRule="evenodd" />
                </svg>
            </summary>
            <div className="font-vg-book text-black text-base leading-130 mt-6" dangerouslySetInnerHTML={{__html: html}}></div>
        </details>
    );
}